import { Link, useLocation } from "react-router-dom";

export function BottomNav() {
    const { pathname } = useLocation();

    const isActive = (path: string) => pathname === path;

    const navItems = [
        { href: "/dashboard", icon: "📊", label: "Dashboard" },
        { href: "/insights", icon: "📈", label: "Insights" },
        { href: "/expenses", icon: "📋", label: "Expenses" },
        { href: "/add", icon: "➕", label: "Add" },
        { href: "/settings", icon: "⚙️", label: "Settings" },
    ];

    return (
        <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-3 flex justify-around max-w-4xl mx-auto">
            {navItems.map((item) => (
                <Link
                    key={item.href}
                    to={item.href}
                    className={`flex flex-col items-center gap-1 text-xs font-medium transition-colors ${isActive(item.href)
                        ? "text-teal-600"
                        : "text-gray-600 hover:text-teal-600"
                        }`}
                >
                    <span>{item.icon}</span>
                    <span>{item.label}</span>
                </Link>
            ))}
        </nav>
    );
}
